import { useEffect, useState } from 'react';
import { useTravelTranslation } from '../../app/TravelLocaleContext';
import { adsMemberApi } from '../../api/adsMemberApi';

function toIsoString(date) {
  return date.toISOString().slice(0, 19);
}

function formatCtr(ctr) {
  if (ctr == null) return '0.00%';
  const num = Number(ctr);
  if (isNaN(num)) return '0.00%';
  // If ctr is already fractional (e.g. 0.0245 -> 2.45%)
  if (num <= 1 && num > 0) {
    return (num * 100).toFixed(2) + '%';
  }
  return num.toFixed(2) + '%';
}

export default function CampaignReportingCard({ campaignId, startAt, endAt }) {
  const { t } = useTravelTranslation();
  const [performance, setPerformance] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError('');

    // 計算預設的查詢區間（預設為過去 30 天或排期範圍）
    const now = new Date();
    const past = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);

    const start = startAt ? String(startAt).slice(0, 19) : toIsoString(past);
    const end = endAt ? String(endAt).slice(0, 19) : toIsoString(now);

    adsMemberApi.reporting
      .performance(campaignId, { start, end })
      .then((data) => {
        if (active) {
          setPerformance(data);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (active) {
          setError(err?.message || '載入成效報表失敗');
          setLoading(false);
        }
      });

    return () => {
      active = false;
    };
  }, [campaignId, startAt, endAt]);

  if (loading) {
    return (
      <section className="ads-detail-section" data-testid="campaign-reporting-loading">
        <h4 className="ads-detail-section__title">{t('travel.ads.reporting.title')}</h4>
        <div className="ads-loading">{t('travel.ads.common.loading')}</div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="ads-detail-section" data-testid="campaign-reporting-error">
        <h4 className="ads-detail-section__title">{t('travel.ads.reporting.title')}</h4>
        <div className="ads-alert ads-alert--error">{error}</div>
      </section>
    );
  }

  const impressions = performance?.qualified_impressions ?? 0;
  const clicks = performance?.unique_clicked_deliveries ?? 0;
  const ctrText = formatCtr(performance?.ctr);

  return (
    <section className="ads-detail-section" data-testid="campaign-reporting-card">
      <h4 className="ads-detail-section__title">{t('travel.ads.reporting.title')}</h4>
      <div className="ads-grid-3">
        <div className="ads-metric">
          <div className="ads-metric__label">{t('travel.ads.reporting.impressions')}</div>
          <div className="ads-metric__value" data-testid="reporting-impressions">
            {impressions}
          </div>
        </div>
        <div className="ads-metric">
          <div className="ads-metric__label">{t('travel.ads.reporting.clicks')}</div>
          <div className="ads-metric__value" data-testid="reporting-clicks">
            {clicks}
          </div>
        </div>
        <div className="ads-metric">
          <div className="ads-metric__label">{t('travel.ads.reporting.ctr')}</div>
          <div className="ads-metric__value" data-testid="reporting-ctr">
            {ctrText}
          </div>
        </div>
      </div>
    </section>
  );
}
